import React, { useEffect, useState } from "react";
import "./hero.css";
import {
  FaChevronDown,
  FaStar,
  FaRegStar,
  FaSnowflake,
  FaGem,
} from "react-icons/fa";
import { GiSparkles } from "react-icons/gi";
import { BsStars } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import logo from "../../assets/conectalm.png";
import { Link } from "react-router-dom";

export default function Hero() {
  const [firstText, setFirstText] = useState("");
  const [secondText, setSecondText] = useState("");
  const [showSecond, setShowSecond] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const firstPhrase = "POSICIONE SUA MARCA";
  const secondPhrase = "E VENDA TODOS OS DIAS";

  const icons = [
    <FaStar />,
    <FaRegStar />,
    <GiSparkles />,
    <BsStars />,
    <MdStars />,
    <FaSnowflake />,
    <FaGem />,
    <span className="ribbon-star">✦</span>,
    <span className="ribbon-star">✧</span>,
    <span className="ribbon-star">⭐</span>,
    <span className="ribbon-star">✨</span>,
  ];

  useEffect(() => {
    let i = 0;
    const typeFirst = setInterval(() => {
      if (i < firstPhrase.length) {
        setFirstText(firstPhrase.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typeFirst);
        setTimeout(() => setShowSecond(true), 500);
      }
    }, 60);

    return () => clearInterval(typeFirst);
  }, []);

  useEffect(() => {
    if (showSecond) {
      let j = 0;
      const typeSecond = setInterval(() => {
        if (j < secondPhrase.length) {
          setSecondText(secondPhrase.substring(0, j + 1));
          j++;
        } else {
          clearInterval(typeSecond);
        }
      }, 60);

      return () => clearInterval(typeSecond);
    }
  }, [showSecond]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  const renderRibbonItems = () => {
    const items = [];
    for (let i = 0; i < 20; i++) {
      const iconIndex = i % icons.length;
      items.push(
        <span className="ribbon-item" key={i}>
          {icons[iconIndex]}
          <span>CONECTALM</span>
        </span>,
      );
    }
    return items;
  };

  const openWhatsApp = () => {
    window.open(
      "https://wa.me/5598986064394?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informações.",
      "_blank",
    );
  };

  const scrollToSobre = (e) => {
    e.preventDefault();
    const sobreSection = document.getElementById("sobre");
    if (sobreSection) {
      sobreSection.scrollIntoView({ behavior: "smooth" });
    }
    closeMenu();
  };

  return (
    <section className="hero-section">
      <div className="hero-navbar">
        <div className="hero-navbar-container">
          <div className="hero-logo">
            <img src={logo} alt="ConectaLM Logo" className="rosa-logo" />
          </div>

          <ul className="hero-nav-links">
            <li>
              <a
                href="#sobre"
                onClick={scrollToSobre}
                className="nav-link-rosa"
              >
                Quem Somos
              </a>
            </li>
            <li>
              <a
                href="#sobre"
                onClick={scrollToSobre}
                className="nav-link-rosa"
              >
                Serviços
              </a>
            </li>
            <li>
              <a href="#resultados" className="nav-link-rosa">
                Resultados
              </a>
            </li>
          </ul>

          {/* Botão MÉTODO ÁPICE - substituindo Contato */}
          <Link to="/metodo-apice" className="hero-btn-metodo-apice">
            Método ÁPICE
          </Link>

          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Abrir menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <div className={`menu-mobile ${isMenuOpen ? "active" : ""}`}>
        <button className="close-menu" onClick={closeMenu}>
          ×
        </button>
        <ul className="menu-mobile-links">
          <li>
            <a href="#sobre" onClick={scrollToSobre}>
              Quem Somos
            </a>
          </li>
          <li>
            <a href="#sobre" onClick={scrollToSobre}>
              Serviços
            </a>
          </li>
          <li>
            <a href="#resultados" onClick={closeMenu}>
              Resultados
            </a>
          </li>
          <li>
            <Link
              to="/metodo-apice"
              onClick={closeMenu}
              className="mobile-link-apice"
            >
              Método ÁPICE
            </Link>
          </li>
        </ul>
      </div>

      <div
        className={`overlay ${isMenuOpen ? "active" : ""}`}
        onClick={closeMenu}
      />

      <div className="hero-container">
        <div className="hero-content">
          <div className="badge-group">
            <h1 className="hero-badge badge-blue hover-to-pink">
              <span className="typed-text">{firstText}</span>
            </h1>
            <h2 className="hero-badge badge-pink hover-to-blue">
              <span className="typed-text">{secondText}</span>
            </h2>
          </div>

          <div className="hero-description">
            <p className="desc-top bold-text">
              CRIAMOS ESTRATÉGIAS DIGITAIS QUE CONECTAM, E GERAM RESULTADOS
              REAIS.
            </p>
            <p className="desc-bottom-bold bold-text">
              A ConectaLM é o impulso estratégico que sua marca precisa para
              crescer e se destacar no digital.
            </p>
          </div>

          <button onClick={openWhatsApp} className="hero-btn">
            Quero posicionar minha marca
            <span className="btn-icon">
              <FaChevronDown className="icon-pulse" />
            </span>
          </button>
        </div>
      </div>

      <div className="hero-footer-ribbon">
        <div className="ribbon-content">
          {renderRibbonItems()}
          {renderRibbonItems()}
        </div>
      </div>
    </section>
  );
}
